import React from 'react';
import {
  Container,
  Row,
  Col,
  Image,
  Carousel,
  Dropdown,
} from 'react-bootstrap';
import { graphql, compose } from 'react-apollo';
import { Link, withRouter } from 'react-router-dom';
import './style.css';
import { Helmet } from 'react-helmet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronCircleLeft,
  faChevronCircleRight,
} from '@fortawesome/free-solid-svg-icons';
import WeekByWeekImages from '../../images/WeekByWeekImages';
import { Trimesters, FAQAccordion } from '../../components';
import ProductRecommendations from '../../components/product-recommendations';
import MetaTagService from '../../services/MetaTagService';
import { StructuredData } from '../../components/structured-data';

// Services
import Logger from '../../services/Logger';
import Environment from '../../services/Environment';
import BBAnalytics from '../../services/BBAnalytics';
import GraphQLTags from '../../services/GraphQLTags';

// Constants
import Content from '../../constants/Content';
import WeekByWeekContent from '../../constants/WeekByWeek';
import trimesterValues from '../../constants/Trimesters';

const isDesktop = window.innerWidth >= 768;

class WeekByWeek extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const weekParam = this.props.match.params.week;
    if (weekParam) {
      // check if url matches '/week-weekNumber'
      let week = parseInt(weekParam.split('-').pop(), 10);
      // if not a number, look for number in the first index
      if (Number.isNaN(week)) {
        week = parseInt(weekParam.split('-')[0], 10);
        if (week && !Number.isNaN(week)) {
          // redirect to '/week-weekNumber'
          this.props.history.push(`/week-by-week/week-${week}`);
        } else {
          this.props.history.push('/week-by-week');
        }
      }
      // check if week is between 4 and 42
      // if not, redirect to week-by-week
      if (week < 4 || week > 42) {
        this.props.history.push('/week-by-week');
      }
    }
  }

  componentDidCatch(error, errorInfo) {
    Logger.error(error, { extra: errorInfo });
  }

  renderFAQSchema(week) {
    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: week.faq.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    };
    return <StructuredData data={faqSchema} />;
  }

  determineTrimesterCSSClass(week) {
    if (week.week < 13) return 'first-trimester';
    if (week.week < 28) return 'second-trimester';
    return 'third-trimester';
  }

  doINeedAnOrA(week) {
    if ([17, 26, 35].includes(week.week)) {
      return "an";
    }

    return "a"
  }

  chunkWeeks = (weeksArray, size) => {
    let index = 0;
    const arrayLength = weeksArray.length;
    const arr = [];

    for (index = 0; index < arrayLength; index += size) {
      const myChunk = weeksArray.slice(index, index + size);
      arr.push(myChunk);
    }
    return arr;
  };

  renderWeekByWeekNavigation = (week) => {
    const prevWeek = week - 1;
    const nextWeek = week + 1;
    return (
      <Row className='my-3'>
        {prevWeek > 3 ? (
          <Col className='weekToWeekNavCol' xs={6} sm={6} md={6} lg={6}>
            <Link to={`/week-by-week/week-${prevWeek}`}>
              <Row className='weekToWeekNavBtnLeft'>
                <Col className='chevronArrow' xs={2} sm={2} md={2} lg={2}>
                  <FontAwesomeIcon icon={faChevronCircleLeft} size='lg' />
                </Col>
                <Col className='prevWeekPregnant' xs={9} sm={9} md={9} lg={9}>
                  {prevWeek} Weeks Pregnant
                </Col>
              </Row>
            </Link>
          </Col>
        ) : (
          <Col className='weekToWeekNavCol' xs={6} sm={6} md={6} lg={6}>
            <Link to='/week-by-week'>
              <Row className='weekToWeekNavBtnLeft'>
                <Col className='chevronArrow' xs={2} sm={2} md={2} lg={2}>
                  <FontAwesomeIcon icon={faChevronCircleLeft} size='lg' />
                </Col>
                <Col className='prevWeekPregnant' xs={9} sm={9} md={9} lg={9}>
                  Week by Week
                </Col>
              </Row>
            </Link>
          </Col>
        )}
        {nextWeek < 43 ? (
          <Col
            className='weekToWeekNavCol textRight'
            xs={6}
            sm={6}
            md={6}
            lg={6}
          >
            <Link to={`/week-by-week/week-${nextWeek}`}>
              <Row className='weekToWeekNavBtnRight'>
                <Col className='nextWeekPregnant' xs={9} sm={9} md={9} lg={9}>
                  {nextWeek} Weeks Pregnant
                </Col>
                <Col className='chevronArrow' xs={2} sm={2} md={2} lg={2}>
                  <FontAwesomeIcon icon={faChevronCircleRight} size='lg' />
                </Col>
              </Row>
            </Link>
          </Col>
        ) : (
          <Col
            className='weekToWeekNavCol textRight'
            xs={6}
            sm={6}
            md={6}
            lg={6}
          >
            <Link to='/week-by-week'>
              <Row className='weekToWeekNavBtnRight'>
                <Col className='nextWeekPregnant' xs={9} sm={9} md={9} lg={9}>
                  Week by Week
                </Col>
                <Col className='chevronArrow' xs={2} sm={2} md={2} lg={2}>
                  <FontAwesomeIcon icon={faChevronCircleRight} size='lg' />
                </Col>
              </Row>
            </Link>
          </Col>
        )}
      </Row>
    );
  };

  renderWeekByWeekProducts = (products, page) => {
    if (!products || !products.length) {
      return null;
    }

    const promoData = {
      id: page,
      name: `${page} Upsell`,
      position: page,
      products,
    };

    BBAnalytics.viewPromo(promoData).catch((err) => Logger.error(err));

    return (
      <ProductRecommendations
        onCartUpdate={this.props.onCartUpdate}
        products={products}
        page={page}
      />
    );
  };

  renderWeekByWeekDropDown = (week) => {
    const weeks = WeekByWeekContent.map((item) => item.week.toString());
    weeks.unshift('week-by-week');
    return (
      <Row className='my-3 weekByWeekDropdown'>
        <Col xs={12} sm={12} md={12} lg={12}>
          <p className='jumpToText'>Jump to </p>
        </Col>
        <Col xs={12} sm={12} md={12} lg={12}>
          <Dropdown>
            <Dropdown.Toggle split id='dropdown-basic'>
              Week {week}{' '}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {weeks.map((weekNum) => {
                if (weekNum !== 'week-by-week') {
                  return (
                    <Dropdown.Item
                      key={weekNum}
                      href={`/week-by-week/week-${weekNum}`}
                    >
                      Week {weekNum}
                    </Dropdown.Item>
                  );
                }
                return (
                  <Dropdown.Item key={weekNum} href='/week-by-week'>
                    Week by Week
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
    );
  };

  renderWeekCarousel = () => (
    <Col xs={12} sm={12} md={12} lg={12}>
      <Carousel indicators={false} interval={null}>
        {!isDesktop
          ? this.chunkWeeks(WeekByWeekContent, 5).map((week) => (
              <Carousel.Item key={week[0].week}>
                <Row className='carousel-item-row'>
                  {week.map((item) => (
                    <Col
                      xs={{ span: 1.5, offset: 0.5 }}
                      sm={{ span: 1.5, offset: 0.5 }}
                      md={{ span: 1.5, offset: 0.5 }}
                      lg={{ span: 1.5, offset: 0.5 }}
                      key={item.week}
                      className='week-carousel-item'
                    >
                      <Link to={`/week-by-week/week-${item.week}`}>
                        <div>
                          <p className='week'>Week</p>
                          <p className='weekNum'>{item.week}</p>
                        </div>
                      </Link>
                    </Col>
                  ))}
                </Row>
              </Carousel.Item>
            ))
          : this.chunkWeeks(WeekByWeekContent, 7).map((week) => (
              <Carousel.Item key={week[0].week}>
                <Row className='carousel-item-row carousel-item-row-desktop'>
                  {week.map((item) => (
                    <Col
                      xs={{ span: 1.5, offset: 0.5 }}
                      sm={{ span: 1.5, offset: 0.5 }}
                      md={{ span: 1.5, offset: 0.5 }}
                      lg={{ span: 1.5, offset: 0.5 }}
                      key={item.week}
                      className='week-carousel-item week-carousel-item-desktop'
                    >
                      <Link to={`/week-by-week/week-${item.week}`}>
                        <div>
                          <p className='week'>Week</p>
                          <p className='weekNum'>{item.week}</p>
                        </div>
                      </Link>
                    </Col>
                  ))}
                </Row>
              </Carousel.Item>
            ))}
      </Carousel>
    </Col>
  );

  renderLandingContent = (products) => (
    <>
      <Row className='mt-3'>
        <Col md={12} lg={12}>
          <h1 className='week-title'>Pregnancy Week by Week</h1>
        </Col>
      </Row>
      <Row className='mt-3'>
        <Col xs={12} sm={12} md={12} lg={12}>
          <Image
            src={WeekByWeekImages.weekByWeek.main.src}
            className='main-img'
            alt={WeekByWeekImages.weekByWeek.main.alt}
            fluid
          />
        </Col>
      </Row>
      <Row className='mt-3'>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className='klaviyo-form-VgaHrH' />
        </Col>
      </Row>
      <Row className='mt-3 week-to-week-carousel'>
        <Col xs={12} sm={12} md={12} lg={12}>
          <h2 className='weekByWeekH2'>
            Explore Your Pregnancy <br /> Week by Week
          </h2>
        </Col>
      </Row>
      <Row className='mb-5'>
        <Col xs={12} sm={12} md={12} lg={12}>
          <Row className='mt-3'>{this.renderWeekCarousel()}</Row>
        </Col>
      </Row>
      {this.renderWeekByWeekProducts(products, 'Week-by-Week Main')}
    </>
  );

  renderWeekByWeekContent = (week, products) => (
    <Row>
      <Col xs={12} sm={12} md={12} lg={12}>
        <Row className='mt-3'>
          <Col xs={12} sm={12} md={12} lg={12}>
            <h1>{week.week} weeks pregnant</h1>
          </Col>
        </Row>

        <Row className={`mt-3 hero-container ${this.determineTrimesterCSSClass(week)}`}>
        <Col xs={0} sm={0} md={1} lg={1} className="order-1"/>
        <Col xs={12} sm={12} md={5} lg={5} className={`hero-text-container ${this.determineTrimesterCSSClass(week)}`}>
            <>
              <h2>Your baby is now the size of {this.doINeedAnOrA(week)}:</h2>
              <h1 className={`${this.determineTrimesterCSSClass(week)}`}>
                {WeekByWeekImages.weekByWeek[week.week].alt.split(':')[0]}
              </h1>
              <h2>{WeekByWeekImages.weekByWeek[week.week].alt.split(': ')[1]}</h2>
            </>
          </Col>
        <Col xs={12} sm={12} md={5} lg={5} className='hero-circle-container'>
        <div className="w2w-circle-wrapper">
          <div className="w2w-circle-border" />
          <div className="w2w-inner-circle">
            <Image
              src={WeekByWeekImages.weekByWeek[week.week].src}
              className='each-week-img'
              alt={WeekByWeekImages.weekByWeek[week.week].alt}
              title={week.header}
            />
          </div>
        </div>
        </Col>
        <Col xs={0} sm={0} md={1} lg={1} className="order-4"/>          
        </Row>






        <Row className='mt-3'>
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={12}
            className='week-by-week-txt-container'
          >
            {/* eslint-disable-next-line */}
            <h2>The Weekly Scoop</h2>
            <div dangerouslySetInnerHTML={{ __html: week.content }} />
          </Col>
        </Row>



        {week.symptoms ? (
          <Row className='mt-3'>
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className='week-by-week-txt-container'
            >
              <h2>Symptoms</h2>
              <div>{week.symptoms}</div>
            </Col>
          </Row>
        ) : null}
        {week.yourBaby ? (
          <Row className='mt-3'>
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className='week-by-week-txt-container'
            >
              <h2>Baby Growth Chart</h2>
              {/* eslint-disable-next-line */}
              <div dangerouslySetInnerHTML={{ __html: week.yourBaby }} />
            </Col>
          </Row>
        ) : null}
        {week.yourBody ? (
          <Row className='mt-3'>
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className='week-by-week-txt-container'
            >
              <h2>Your Body</h2>
              {/* eslint-disable-next-line */}
              <div dangerouslySetInnerHTML={{ __html: week.yourBody }} />
            </Col>
          </Row>
        ) : null}
        {week.faq ? (
          <FAQAccordion
            title={`Frequently Asked Questions for Week ${week.week}`}
            FAQs={week.faq}
            useH3
            questionAsEventKey
          />
        ) : null}
        <div className='mb-3  week-to-week-carousel'>
          <Row className='mt-3'>
            <Col xs={12} sm={12} md={12} lg={12} className='weekByWeekNavTitle'>
              <h3>
                Explore Your Pregnancy <br /> Week by Week
              </h3>
              {this.renderWeekByWeekDropDown(week.week)}
            </Col>
          </Row>
          {this.renderWeekByWeekNavigation(week.week)}
          {this.renderWeekByWeekProducts(products, `Week-by-Week ${week.week}`)}
        </div>
      </Col>
    </Row>
  );

  render() {
    window.scrollTo(0, 0);

    const overallWeekByWeekDescription =
      'Get updates for your pregnant belly starting at 4 weeks pregnant!';

    let week;
    let months;
    let weekDescription;
    if (this.props.match.params.week) {
      week = parseInt(this.props.match.params.week.split('-').pop(), 10);
      const numOfMonths = Math.ceil((week * 7) / 31);
      months = numOfMonths > 9 ? 9 : numOfMonths;
      weekDescription = `When you’re ${week} weeks pregnant, you are considered to be ${months} months pregnant. Get updates for your ${week} weeks pregnant bump!`;
    }
    const { getProducts } = this.props.getProductsQuery;
    return (
      <Container className='weekByWeekMainPage'>
        <Helmet>
          <title>
            {!this.props.match.params.week
              ? 'Pregnancy Week by Week Updates'
              : `${this.props.match.params.week
                  .split('-')
                  .pop()} Weeks Pregnant Ultrasound, Symptoms and More`}
          </title>
          <meta
            name='description'
            content={
              !this.props.match.params.week
                ? overallWeekByWeekDescription
                : weekDescription
            }
          />
          <meta
            property='og:title'
            content={MetaTagService.getTemplatedTitle(
              `${
                !this.props.match.params.week
                  ? 'Pregnancy Week by Week Updates'
                  : `${this.props.match.params.week
                      .split('-')
                      .pop()} Weeks Pregnant Ultrasound, Symptoms and More`
              }`,
            )}
          />
          <meta
            property='og:description'
            content={
              !this.props.match.params.week
                ? overallWeekByWeekDescription
                : weekDescription
            }
          />
          <meta
            property='og:image'
            content={
              !this.props.match.params.week
                ? Content.names.mainUrl + WeekByWeekImages.weekByWeek.main.src
                : Content.names.mainUrl +
                  WeekByWeekImages.weekByWeek[
                    this.props.match.params.week.split('-').pop()
                  ].src
            }
          />
          <meta
            name='twitter:title'
            content={MetaTagService.getTemplatedTitle(
              `${
                !this.props.match.params.week
                  ? 'Pregnancy Week by Week Updates'
                  : `${this.props.match.params.week
                      .split('-')
                      .pop()} Weeks Pregnant Ultrasound, Symptoms and More`
              }`,
            )}
          />
        </Helmet>
        {week && week > 3 && week < 43
          ? this.renderWeekByWeekContent(
              WeekByWeekContent[week - 4],
              getProducts,
            )
          : this.renderLandingContent(getProducts)}
        <Trimesters chunk={this.chunkWeeks} />
      </Container>
    );
  }
}

const WeekByWeekWithData = compose(
  graphql(GraphQLTags.queries.getProductsQuery, {
    name: 'getProductsQuery',
    options: (ownProps) => {
      let week;
      let trimester;
      let trimesterName;
      if (ownProps.match.params.week) {
        week = parseInt(ownProps.match.params.week.split('-').pop(), 10);
        if (Number.isNaN(week)) {
          week = parseInt(ownProps.match.params.week.split('-')[0], 10);
        }
        trimesterValues.forEach((trimesterObj) =>
          trimesterObj.weeks.forEach((weekNum) => {
            if (week === weekNum) trimesterName = trimesterObj.title;
          }),
        );
        if (trimesterName === 'First Trimester') trimester = 'Trimester 1';
        if (trimesterName === 'Second Trimester') trimester = 'Trimester 2';
        if (trimesterName === 'Third Trimester') trimester = 'Trimester 3';
        if (!trimesterName) trimester = 'All Trimesters';
      } else {
        trimester = 'All Trimesters';
      }

      const description = trimester;

      return {
        variables: {
          tagDescription: description || '',
          sortFilter: 'DISPLAY_ORDER',
          offset: 0,
          limit: 4,
          provider: Environment.store,
          customerIdForAdmin: localStorage.getItem('customerId') || '',
        },
        notifyOnNetworkStatusChange: true,
      };
    },
  }),
)(withRouter(WeekByWeek));

export default WeekByWeekWithData;
